import React, { Component } from 'react';
import {useTable} from 'react-table';
import styled from 'styled-components'
const Styles = styled.div `
  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid black;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 1rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;
      :last-child {
        border-right: 0;
      }
    }
  }
`
function Table({columns, data}) {
    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} = useTable({columns, data})
    // Render Data Table UI
    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup
                .headers
                .map(column => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row
                  .cells
                  .map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }


export class DivisionTable extends Component {

    constructor(props) {
        super(props);
        this.divisionName = props.title;
        this.divprefix = props.divprefix;
        this.standingsData = props.data;
        this.state = { divisionRecords: [],loading: true  };

        
        this.divisionColumns = [
            {
                accessor: 'teamname',
                Header: 'Team',
            }, 
        {
            accessor: 'wins',
            Header: 'W',
        }, 
        {
            accessor: 'losses',
            Header: 'L',
        }, 
        {
            accessor: 'pointsFor',
            Header: 'PF',
        }, 
        {
            accessor: 'pointsAgainst',
            Header: 'PA',
        }, 
        {
            accessor: 'diff',
            Header: 'DIFF',
        }, 
    ];
   }

    componentDidMount() {
        this.populateStandings(this.divprefix,this.standingsData);
    }


    static renderDivisionTable(divisionRecords,divisionName,divisionColumns) {
        return (
            <div>
                <h2>{divisionName}</h2>
                <Styles>
                    <Table
                        data={divisionRecords}
                        columns={divisionColumns}
                    />
                </Styles>
                 <br/>
                </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : DivisionTable.renderDivisionTable(this.state.divisionRecords,this.divisionName,this.divisionColumns);

        return (
            <div>
                {contents}
            </div>
        );
    }

    async populateStandings(divPrefix,standingsData) {
        var results = DivisionTable.filterByValue(standingsData, divPrefix);
        results.sort((a, b) => (b.wins - a.wins || a.losses - b.losses ));
            this.setState({ divisionRecords: results, loading: false });
    }

    

    static filterByValue = (arr = [], query = '') => {
        const reg = new RegExp(query, 'i');
        return arr.filter((item) => {
            let flag = false;
           
                if (reg.test(item.teamid)) {
                    flag = true;
                }
            
            return flag;
        });
    }
}